import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select from "react-select";

class GameTypeInput extends Component {
    state = {
        game_types: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.gameTypesArr && this.props.gameTypesArr.length > 0) {
            this.setState({ game_types: this.props.gameTypesArr, isLoading: false });
        } else {
            this.fetchGameTypes();
        }
    }

    fetchGameTypes = () => {
        axios.get(apiUrl + 'GameTypes/getGameTypes')
            .then(response => {
                this.setState({ game_types: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching game types:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { game_types, isLoading, isError } = this.state;
        const { game_types_filter, gameTypesUpdate, updatePage, closeGameDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading game types. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading game types..."
                />
            );
        }

        // Handle normal state with data
        const options = game_types.map(game_type => ({
            value: game_type.game_type_id,
            label: game_type.game_type_name,
            color: '#9999FF'
        }));
        const animatedComponents = makeAnimated();

        const defaultOptions = game_types_filter.map(game_type_id => {
            return options.find(option => option.value === game_type_id) || { value: 0, label: "Invalid game type id", color: '#9999FF' };
        });

        return (
            <Select
                isMulti
                isSearchable
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder="Select game types to search by."
                onChange={(val) => {
                    const retArr = val ? val.map(e => e.value) : [];
                    // console.log(retArr);
                    gameTypesUpdate(retArr);
                    updatePage(0);
                    closeGameDetails(null);
                }}
            />
        );
    }
}

export default GameTypeInput;